import { getDataMapper, mapArray, mapField } from "@/shared";

export const mapDirectorAddonFromServer = getDataMapper({
    id: mapField("id", Number),
    type: mapField("type"),
    title: mapField("title"),
    value: mapField("value", Number),
    price: mapField("price", Number),
    timeStart: mapField("time_start"),
    timeEnd: mapField("time_end"),
    autoRenew: mapField("auto_renew", Boolean),
});

export const mapDirectorAddonsFromServer = mapArray(mapDirectorAddonFromServer);
